import { render, staticRenderFns } from "./TraceTokens.vue?vue&type=template&id=20517ffc&"
import script from "./TraceTokens.vue?vue&type=script&lang=js&"
export * from "./TraceTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TraceTokens.vue"
export default component.exports